import { render, staticRenderFns } from "./export-table.vue?vue&type=template&id=21939e04&"
import script from "./export-table.vue?vue&type=script&lang=js&"
export * from "./export-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports